import React, { FunctionComponent, memo, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import NavigationBarButton from '../../BaseComponents/Button/NavigationBar'
import { IconProps } from '../NavigationBar/Icon/IconProps'
import { TestID } from '../../utils/PropTypesDefinitions'

export type NavigationBarIconProps = IconProps &
    TestID & {
        onPress: () => void
        size?: number
    }
export type NavigationBarProps = {
    icons?: NavigationBarIconProps[]
}

const NavigationIconRow: FunctionComponent<NavigationBarProps> = ({ icons }): ReactElement => {
    return (
        <Grid pointerEvents="box-none" horizontal noExpand alignRight>
            {icons?.map(item => (
                <NavigationBarButton
                    key={item.name}
                    name={item.name}
                    color={item.color}
                    size={item.size}
                    onPress={item.onPress}
                    testID={item.testID}
                />
            ))}
        </Grid>
    )
}

export default memo(NavigationIconRow)
